import script from "./SchoolList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SchoolList.vue?vue&type=script&lang=ts&setup=true"

import "./SchoolList.vue?vue&type=style&index=0&id=1c4820d2&scoped=true&lang=css"
script.__scopeId = "data-v-1c4820d2"

export default script